import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CreateBingoView } from "../../views/CreateBingoView";
import { PlayBingoView } from "../../views/PlayBingoView";
import { MessageView } from "../../views/MessageView";
import { ObsView } from "../../views/ObsView";
import { GlobalHeader } from "./GlobalHeader";
import { Footer } from "./Footer";
import { getStoredTheme } from "../../utils/theme";
import "./App.css";

export const BingoApp: React.FC = () => {
  const location = useLocation();
  const [theme, setTheme] = useState<"dark" | "light">(() => getStoredTheme());

  // Don't show GlobalHeader or Footer on OBS view
  const isObsView = location.pathname.startsWith("/obs/");
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (isObsView) {
      document.body.classList.add("obs-view-active");
    } else {
      document.body.classList.remove("obs-view-active");
    }

    // Add bingo-view class for CSS scoping
    document.body.classList.add("bingo-view");
    document.body.classList.remove("healthbar-view");
  }, [isObsView]);

  useEffect(() => {
    document.body.classList.remove("theme-dark", "theme-light");
    document.body.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <div className={`App theme-${theme} bingo-view`}>
      {!isObsView && <GlobalHeader onThemeChange={setTheme} />}
      <Routes>
        <Route path="/" element={<CreateBingoView />} />
        <Route path="/play/:code" element={<PlayBingoView />} />
        <Route path="/obs/:code/:playerId" element={<ObsView />} />
        <Route path="/message" element={<MessageView />} />
        <Route
          path="*"
          element={
            <div
              style={{
                padding: "20px",
                textAlign: "center",
                color: "var(--text-color)",
              }}
            >
              <h1>404 - Page Not Found</h1>
              <a href="/" style={{ color: "#667eea" }}>
                Go Home
              </a>
            </div>
          }
        />
      </Routes>
      {!isObsView && <Footer variant={isHomePage ? "sidebar" : "bottom"} />}
    </div>
  );
};
